import { safeCaptionTokens } from './safeCaptionTokens';

type Translate = (key: string, values?: Record<string, unknown>) => string;
const CODE = 'cpm_required_caption_tokens_missing';
const record = (value: unknown): Record<string, unknown> => value && typeof value === 'object' ? value as Record<string, unknown> : {};

/** Read only structured, bounded token lists; never render provider payloads. */
export function captionSubmissionFeedback(error: unknown, t: Translate): string | null {
  const root = record(error);
  const entries = [...(Array.isArray(root.graphQLErrors) ? root.graphQLErrors : []), ...(Array.isArray(root.errors) ? root.errors : []), root].map(record);
  const match = entries.find(entry => {
    const nested = record(record(entry.extensions).error);
    return entry.message === CODE || nested.message === CODE || record(entry.extensions).code === CODE;
  });
  if (!match) return null;
  const extensions = record(match.extensions);
  const details = { ...record(record(extensions.error).details), ...extensions };
  const hashtags = safeCaptionTokens(details.missingHashtags, '#').join(', ');
  const mentions = safeCaptionTokens(details.missingMentions, '@').join(', ');
  return [t(`campaign.submit.errors.${CODE}`), hashtags && t('campaign.submit.missingHashtags', { tokens: hashtags }), mentions && t('campaign.submit.missingMentions', { tokens: mentions }), t('campaign.submissions.captionTokens.hint')].filter(Boolean).join(' ');
}
